function getCartSectionId() {
  const pageCart = document.querySelector('#page-cart');
  return pageCart?.dataset.sectionId || '';
}

function updateHeaderCartCount(itemCount) {
  document.querySelectorAll('[data-cart-count]').forEach((el) => {
    if (el.classList.contains('cart-heading__count') || el.classList.contains('cart-drawer__heading-count')) {
      el.textContent = `(${itemCount})`;
      return;
    }

    el.textContent = itemCount > 0 ? String(itemCount) : '';
  });

  document.querySelectorAll('.unilar-mobile-cart-count').forEach((el) => {
    if (itemCount > 0) {
      el.textContent = String(itemCount);
      el.style.display = '';
    } else {
      el.textContent = '';
      el.style.display = 'none';
    }
  });
}

function refreshCartPage() {
  const pageCart = document.querySelector('#page-cart');
  if (!pageCart) return Promise.resolve();

  const sectionId = getCartSectionId();
  const url = sectionId ? `/cart?section_id=${sectionId}` : '/cart';

  return fetch(url)
    .then((response) => response.text())
    .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      const newPageCart = html.querySelector('#page-cart');

      if (!newPageCart) return;

      pageCart.innerHTML = newPageCart.innerHTML;

      if (typeof updatePixTotalVisibility === 'function') {
        updatePixTotalVisibility(pageCart);
      }

      const countEl = newPageCart.querySelector('[data-cart-count]');
      if (countEl) {
        const match = countEl.textContent.match(/\d+/);
        if (match) {
          updateHeaderCartCount(parseInt(match[0], 10));
        }
      }
    })
    .catch((error) => {
      console.error('Erro ao atualizar carrinho:', error);
    });
}

function changeCartItemQuantity(variantKey, quantity) {
  return fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantKey, quantity }),
  }).then((response) => {
    if (!response.ok) {
      return response.json().then((data) => {
        throw new Error(data.description || data.message || 'Erro ao atualizar carrinho');
      });
    }

    return response.json();
  });
}

class CartItemManager extends HTMLElement {
  connectedCallback() {
    this.variantKey = this.dataset.variantKey;
    this.quantity = parseInt(this.dataset.quantity || '1', 10);
    this.isUpdating = false;

    this.addEventListener('click', this.handleClick.bind(this));
  }

  handleClick(event) {
    const button = event.target.closest('[data-action]');
    if (!button || !this.contains(button) || this.isUpdating) return;

    const action = button.dataset.action;

    if (action === 'remove') {
      event.preventDefault();
      this.updateQuantity(0);
      return;
    }

    if (action === 'increase') {
      event.preventDefault();
      this.updateQuantity(this.quantity + 1);
      return;
    }

    if (action === 'decrease') {
      event.preventDefault();
      if (this.quantity <= 1) {
        this.updateQuantity(0);
      } else {
        this.updateQuantity(this.quantity - 1);
      }
    }
  }

  updateQuantity(quantity) {
    if (!this.variantKey || this.isUpdating) return;

    this.isUpdating = true;
    this.classList.add('is-updating');

    changeCartItemQuantity(this.variantKey, quantity)
      .then((cart) => {
        updateHeaderCartCount(cart.item_count);
        return refreshCartPage();
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        this.isUpdating = false;
        this.classList.remove('is-updating');
      });
  }
}

class CartClearButton extends HTMLElement {
  connectedCallback() {
    this.modal = this.querySelector('[data-clear-cart-modal]');
    this.overlay = this.querySelector('[data-modal-overlay]');
    this.isUpdating = false;

    this.addEventListener('click', this.handleClick.bind(this));
  }

  handleClick(event) {
    const button = event.target.closest('[data-action]');
    if (!button || !this.contains(button)) return;

    const action = button.dataset.action;

    if (action === 'clear-cart') {
      event.preventDefault();
      this.openModal();
      return;
    }

    if (action === 'cancel-clear') {
      event.preventDefault();
      this.closeModal();
      return;
    }

    if (action === 'confirm-clear') {
      event.preventDefault();
      this.clearCart();
    }
  }

  openModal() {
    this.modal?.classList.add('is-active');
  }

  closeModal() {
    this.modal?.classList.remove('is-active');
  }

  clearCart() {
    if (this.isUpdating) return;

    this.isUpdating = true;

    fetch('/cart/clear.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
    })
      .then((response) => {
        if (!response.ok) throw new Error('Erro ao limpar carrinho');
        return response.json();
      })
      .then((cart) => {
        updateHeaderCartCount(cart.item_count || 0);
        this.closeModal();
        return refreshCartPage();
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        this.isUpdating = false;
      });
  }
}

class CartCrossSellItem extends HTMLElement {
  connectedCallback() {
    this.variantId = this.dataset.variantId;
    this.isUpdating = false;

    this.addEventListener('click', this.handleClick.bind(this));
  }

  handleClick(event) {
    const button = event.target.closest('[data-action="add-to-cart"]');
    if (!button || !this.contains(button) || this.isUpdating) return;

    event.preventDefault();
    event.stopPropagation();
    this.addToCart(button);
  }

  addToCart(button) {
    if (!this.variantId) return;

    this.isUpdating = true;
    button.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: this.variantId, quantity: 1 }),
    })
      .then((response) => {
        if (!response.ok) {
          return response.json().then((data) => {
            throw new Error(data.description || data.message || 'Erro ao adicionar produto');
          });
        }

        return response.json();
      })
      .then(() => fetch('/cart.js'))
      .then((response) => response.json())
      .then((cart) => {
        updateHeaderCartCount(cart.item_count);
        return refreshCartPage();
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        this.isUpdating = false;
        button.disabled = false;
      });
  }
}

if (!customElements.get('cart-item-manager')) {
  customElements.define('cart-item-manager', CartItemManager);
}

if (!customElements.get('cart-clear-button')) {
  customElements.define('cart-clear-button', CartClearButton);
}

if (!customElements.get('cart-cross-sell-item')) {
  customElements.define('cart-cross-sell-item', CartCrossSellItem);
}
